
import { User } from '../auth/User';
import { UserMembership } from '../types/UserMembership';
import { ApiRoutes, getFullApiRoute, replaceRouteParams } from './ApiRoutes';
import { HttpRequest } from './HttpRequest';

export class MemberAPI {
    //Get all memberships of a company
    static async getAll(user: User): Promise<UserMembership[]> {
        const result = await HttpRequest(
            replaceRouteParams(getFullApiRoute(ApiRoutes.COMPANY_MEMBERSHIPS), {"id": user.attributes.tenant_id}),
            'GET',
            null,
            null,
            user
        );
        return result?.data || [];
    }
    
    //Update a users membership in your company
    static async updateOne(user: User, data: UserMembership): Promise<any> {
        const result = await HttpRequest(
            replaceRouteParams(getFullApiRoute(ApiRoutes.COMPANY_MEMBERSHIPS), {"id": user.attributes.tenant_id})+`/${data.userId}`,
            'PUT',
            data,
            new Headers({'Content-Type': 'application/json'}),
            user
        );
        //Check if we have a result and if it is object or array, if array just retun the first item as that is what we expect
        return result && result.data ? (Array.isArray(result.data) ? result.data[0] : result.data) : undefined;
    }
}